// import JourneyEditor from './components/Viewport.vue'
import vm, { getLocalStorageItem } from './Journeys.viewmodel'
import Journeys from './Journeys.vue'
import JourneyHome from './Pages/JourneyStart.vue'
import JourneyNew from './Pages/JourneyNew.vue'

import ScrollableContainer from '@shared/components/ScrollableContainer.vue'
import { rootElement } from '@shared/setup'
import { createRouter, createWebHistory } from 'vue-router'

import '@shared/styles/align-and-spacing.css'
import '@shared/styles/app-defaults.css'
import '@shared/styles/containers.css'
import '@shared/styles/inputs.css'
import '@shared/styles/transitions.css'

const initJourney = async () => {
    let viewportComponent = await import('/Journeys/components/Viewport.vue')

    const routes: any[] = [
        { path: '/', redirect: '/drafts' },
        { path: '/:drafts|active|ended|templates', component: JourneyHome, props: true },
        { path: '/new', component: JourneyNew, props: true },
        {
            path: '/:JourneyId([\\w\\-]{36})',
            component: viewportComponent.default,
            props: true,
        },
    ]
   
    const router = createRouter({
        history: createWebHistory('/journeys'),
        routes,
    })

    vm.router = router

    rootElement({
        name: 'JourneyBuilder', // pascal, camel & kebab-case are valid
        component: Journeys,
        vm,
        router,
        contextComponents: [ScrollableContainer],
    })
}

initJourney()

//** prep for admin utilities
//** testing markup resource editor to start with
/** mod mode state */
let admin_tools = false,
    editing_resource: string | null = null

/** contains currently edited resources */
const editedResources: Indexable<string, string> = {}

/** from point, check if text node. if value is a resource string add key to dataset & set 'contenteditable' attribute to element */
const resourceTextElementFromPoint = (ev: any) => {
    ev.stopPropagation()
    // ev.preventDefault()

    let el = document.elementFromPoint(ev.x, ev.y) as HTMLElement
    console.log('from point', el.childNodes[0]?.nodeType, Node.TEXT_NODE, el.dataset.mod_reskey)
    if (!el) return

    if (el.dataset.mod_reskey) editResource(el)
    else if (el.childNodes[0]?.nodeType === Node.TEXT_NODE) getResourceKey(el)
}

const editResource = (el: HTMLElement) => {
    let key = el.dataset.mod_reskey

    if (!key || editing_resource === key) return
    editing_resource = key

    console.log('editing:', editing_resource)

    el.classList.add('editable-resource')

    let handleInput: any
    el.addEventListener(
        'input',
        (handleInput = () => {
            editedResources[key!] = el.innerText.replace(/:\s?$/g, '')
        })
    )

    el.addEventListener(
        'blur',
        () => {
            el.classList.remove('editable-resource')

            console.log(key, 'updated, new value:', el.innerText)
            console.log('Edited resources:', '\n', JSON.stringify(editedResources))

            el.removeEventListener('input', handleInput)
        },
        { once: true }
    )
}

const getResourceKey = (el: HTMLElement) => {
    let regexp = new RegExp(
        el.innerText
            .replace(/[-\/\\^$*+?.()|\[\]{}]/g, '\\$&') // escape!
            .replace(/:\s?$/g, '$&?'), // account for hardcoded suffix characters
        'mi'
    )
    // $Resources.
    for (let reskey in $Resources) {
        if (regexp.test($Resources[reskey])) {
            el.dataset.mod_reskey = reskey
            el.contentEditable = 'true'

            editResource(el)
            break
        }
    }
}

export const    toggleAdminTools = (val: boolean = !admin_tools) => {
    console.log('admin_tools:', val)

    if ((admin_tools = val)) document.addEventListener('mousedown', resourceTextElementFromPoint)
    else document.removeEventListener('mousedown', resourceTextElementFromPoint)

    vm.editor.dev.show.admin_tools = val
}
